module.exports = "https://coursera_assets.s3.amazonaws.com/images/0359899ff17a0040c7bd28aacf206c45.png";